export const ORG_ROLE_RANK = {
  viewer: 0,
  member: 1,
  admin: 2,
  owner: 3,
};

export function getOrgRole(user) {
  return user?.organizationRole || "viewer";
}

export function hasMinOrgRole(user, minRole) {
  const role = getOrgRole(user);
  return (ORG_ROLE_RANK[role] ?? 0) >= (ORG_ROLE_RANK[minRole] ?? 0);
}

export function canManageIntegrations(user) {
  return hasMinOrgRole(user, "admin");
}

export function canMutateRepos(user) {
  return hasMinOrgRole(user, "member");
}

export function canDeleteRepos(user) {
  return hasMinOrgRole(user, "admin");
}

export function canManageWorkspace(user) {
  return hasMinOrgRole(user, "admin");
}

export function canViewMembers(user) {
  return hasMinOrgRole(user, "admin");
}

export function canInviteRole(user, targetRole) {
  const actorRole = getOrgRole(user);
  if ((ORG_ROLE_RANK[actorRole] ?? 0) < ORG_ROLE_RANK.admin) return false;
  if (targetRole === "admin") return actorRole === "owner";
  return true;
}

export function canChangeMemberRole(user, targetCurrentRole, targetNewRole) {
  const actorRole = getOrgRole(user);
  if (actorRole === "owner") return true;
  if (actorRole !== "admin") return false;
  if (targetCurrentRole === "owner" || targetCurrentRole === "admin") return false;
  if (targetNewRole === "owner" || targetNewRole === "admin") return false;
  return true;
}

export function canRemoveMember(user, targetRole, actorUserId, targetUserId) {
  const actorRole = getOrgRole(user);
  if (actorUserId === targetUserId) return false;
  if (actorRole === "owner") return targetRole !== "owner";
  if (actorRole === "admin") {
    return targetRole === "member" || targetRole === "viewer";
  }
  return false;
}

export function isWorkspaceReadOnly(user) {
  return getOrgRole(user) === "viewer";
}

export function roleDisplayName(role) {
  if (role === "member") return "Engineer";
  if (!role) return "Viewer";
  return role.charAt(0).toUpperCase() + role.slice(1);
}

export const VIEWER_READ_ONLY_MESSAGE =
  "Your workspace role is read-only. Contact an owner or admin to run analysis workflows.";
